import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CtoComponent } from './cto.component';
import { CtoDetailsComponent } from './cto-details/cto-details.component';
import { NewCtoComponent } from './new-cto/new-cto.component';
import { EditCtoComponent } from './edit-cto/edit-cto.component';
import { CtoKkmHistoryComponent } from './cto-kkm-history/cto-kkm-history.component';

const routes: Routes = [
  {
    path: '', component: CtoComponent,
  },
  {
    path: 'new', component: NewCtoComponent,
  },
  {
    path: ':id', component: CtoDetailsComponent,
  },
  {
    path: 'edit/:id', component: EditCtoComponent,
  },
  {
    path: 'history/:ctoId/:kkmId', component: CtoKkmHistoryComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CtoRoutingModule {}
